<template>
<div role="rowgroup" class="row col-12 px-0 mx-0">
    <div class="row col-12 px-0 pb-1 mx-0 header" role="row">
        <div v-for="(column, index) in columnData" :class="column.classMarkers" role="columnheader">
            <p :id="getHeaderId('dataheader',index)" class="h5 theme-primary pr-1 m-0 d-inline-flex font-weight-bold">{{column.name}}</p>
            <fa-icon v-if="column.info !== null" :icon="['fas','info-circle']" aria-hidden="false" tabindex="0" class="icon" v-tooltip="column.info" />
        </div>
        <slot></slot>
    </div>
</div>
</template>

<script>
    export default {
        name: "DataHeader",

        props: {
            columnData: Object,
            getHeaderId: {
                type: Function,
                default: () => null
            }
        }
    }
</script>

<style scoped>
    .header.row {
        border-bottom: 2px solid var(--header-row-border-color);
    }
</style>
